module.exports = __webpack_public_path__ + "media/assets_v3/images/messages_no_pending_sales-65a2ccbe3757499c69033ba987cd214a.png";